import React, {Component} from 'react';
import * as func from "../../../../../utils/functions";
import ReactPaginate from "react-paginate";

class AuthorPopup extends Component {
	constructor(props) {
		super(props);

		this.state = {
			param: {
				'record_per_page': 5,
				'term_name': ['표제어'],
				'term_status': ['publish'],
				current_page: 1,
				ks : this.props.ks,
			},
			field: 'author',
			records: [],
			totalRecords: 0,
			totalPage: 0,
			pkKey: 'scholar_id',
			action: 'admin/scholars',
			record: {
				scopus_id: "",
				position_name: "",
				memo: "",
				authority_id: '',
				term_parent: 0,
				kci_id: "",
				term_status: "publish",
				authority_term: "",
				// authority_name: "",
				term_type: "heading",
				position_type: "",
				wos_id: ""
			}
		}

		this.onChange = this.onChange.bind(this);
		this.search = this.search.bind(this);
	}

	componentDidMount() {
		if (this.props.showAuthorPopup) {
			let param = this.state.param
			func.getData(this.state.action, param).then((response) => {
				this.setState({
					isInit: true,
					records: response.records,
					facet: response.facet,
					totalRecords: response.pageInfo.totalResults,
					totalPage: response.pageInfo.totalPage,
				})
			});
		}
	}

	// change = () => {
	// 	let record = this.state.record;
	// 	record[event.target.name] = event.target.value;
	// 	this.props.onUpdate(this.props.arrIndex, record, true);
	// }

	onChange = (event) => {
		event.preventDefault();
		let param = this.state.param
		param.ks = event.target.value;
		this.setState({param: param})
		this.forceUpdate()
	}

	onKeyDown = (event) => {
		if (event.key === "Enter") {
			event.preventDefault();
			this.search()
		}
	}

	search = (event) => {
		if(event)
			event.preventDefault();

		func.getData(this.state.action, this.state.param).then((response) => {
			this.setState({
				isInit: true,
				records: response.records,
				facet: response.facet,
				totalRecords: response.pageInfo.totalResults,
				totalPage: response.pageInfo.totalPage,
			})
		});
	}

	set = (record) => {
		this.props.set(record)
	}

	handlePageClick = (page) => {
		const paged = page.selected + 1;

		let param = this.state.param;
		param.current_page = paged;

		func.getData(this.state.action, param).then((response) => {
			this.setState({
				isInit: true,
				records: response.records,
				facet: response.facet,
				totalRecords: response.pageInfo.totalResults,
				totalPage: response.pageInfo.totalPage,
				param: param
			})
		});
	}

	// change = () => {
	// 	let record = this.state.record;
	// 	record[event.target.name] = event.target.value;
	// 	this.setState({record: record})
	// 	this.forceUpdate()
	// }

	render() {
		if (!this.props.showAuthorPopup)
			return ''
		return (
			<div id="search_heading_term" className="modal-mask modal-rm">
				<div className="modal-wrapper">
					<div className="modal-container modal-content">
						<div className="modal-header"><h1 className="modal-title">저자 검색</h1>
							<button type="button" className="close" onClick={() => this.props.setAuthorPopup(false)}>
								<span aria-hidden="true">×</span>
							</button>
						</div>
						<div className="modal-body">
							<div className="row">
								<div className="col">
									<div className="form-group form-inline">
										<input type="text" value={this.state.param.ks}
										       name="ks"
										       ref={(ref) => this.ks = ref}
										       placeholder="저자 검색 결과" className="form-control form-control-sm"
										       onChange={this.onChange}
										       onKeyDown={this.onKeyDown} />
										<button type="button" className="btn btn-primary btn-sm save ml-1"
										        onClick={this.search}>검색
										</button>
									</div>
									<table className="table table-thin border-bottom modal-resource-author-list">
										<thead>
										<tr>
											<th scope="col">ID</th>
											<th scope="col">이름</th>
											<th scope="col">교번</th>
											<th scope="col">신분</th>
											<th scope="col">학과</th>
											<th scope="col">이메일</th>
											<th scope="col">핫포인트</th>
										</tr>
										</thead>
										<tbody>
										{this.state.records.map((record, index) => {
											return (
												<tr key={'p' + record.scholar_id} className="list-row" onClick={() => this.set(record)}>
													<td>{record.scholar_id}</td>
													<td>{record.scholar_name}</td>
													<td>{record.school_no}</td>
													<td>{record.sinbun_name}</td>
													<td>{record.dept_name}</td>
													<td>{record.email}</td>
													<td>{record.hotpoint}</td>
												</tr>
											)
										})}
										{this.state.records.length <= 0 &&
										<tr className="list-row">
											<td colSpan={4}>검색 결과가 없습니다.</td>
										</tr>
										}
										</tbody>
									</table>

									<ReactPaginate
										forcePage={Number(this.state.param.current_page) - 1}
										pageCount={this.state.totalPage}
										marginPagesDisplayed={2}
										pageRangeDisplayed={2}
										onPageChange={this.handlePageClick}
										containerClassName={'pagination'}
										activeClassName={'active'}
										pageClassName={'page-item'}
										pageLinkClassName={'page-link'}
										previousClassName={'page-item page-item-prev'}
										previousLinkClassName={'page-link'}
										nextClassName={'page-item page-item-next'}
										nextLinkClassName={'page-link'}
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default AuthorPopup;